export const APPS_FEATURE = 'appsFeature';

export const APPS = 'apps';

export const RELEASES = 'releases';

export const APPS_FILES = 'appsFiles';

export const MANDANTS = 'mandants';

export const FIRMWARE = 'firmware';

export const CAMPAIGNS_FEATURE = 'campaignsFeature';

export const BASIC_INFO = 'basicInfo';

export const VEHICLE_POPULATION = 'vehiclePopulation';

export const VEHICLE_REPORTS = 'vehicleReports';

export const CAMPAIGNS = 'campaigns';

export const ROOT = 'root';

export const REVIEWS = 'reviews';

export const WEB_GAMES = 'webGames';

export const STATISTICS = 'statistics';
